import { render } from "./TambahPOKJA.vue?vue&type=template&id=981ee7f8"
import script from "./TambahPOKJA.vue?vue&type=script&lang=js"
export * from "./TambahPOKJA.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__